"use client";

import { ArrowUpRight, CircuitBoard, Cpu, Layers, Microchip, Package, Wrench } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhatWeHandle() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const headingWords = ["Precision,", "meticulously", "engineered."];
  const capabilities = [{
    index: "01",
    title: "Advanced PCB Fabrication",
    description: "From design files to physical boards in under 48 hours. High-precision manufacturing using industrial-grade substrates and tight tolerances.",
    icon: CircuitBoard,
    span: "lg:col-span-5",
    featured: true
  }, {
    index: "02",
    title: "Global Component Sourcing",
    description: "Verified electronic parts procurement with full supply chain transparency and quality assurance.",
    icon: Package,
    span: "lg:col-span-3",
    featured: false
  }, {
    index: "03",
    title: "Design Integrity Audit",
    description: "Comprehensive engineering reviews to identify potential failures before production begins.",
    icon: Layers,
    span: "lg:col-span-3",
    featured: false
  }, {
    index: "04",
    title: "Micro-Soldering Services",
    description: "Specialized rework and restoration for high-density, fine-pitch electronic components.",
    icon: Microchip,
    span: "lg:col-span-3",
    featured: false
  }, {
    index: "05",
    title: "System Integration",
    description: "Boot-loaders, driver development, and hardware validation. We ensure your silicon communicates perfectly with your software stack.",
    icon: Cpu,
    span: "lg:col-span-4",
    featured: true
  }, {
    index: "06",
    title: "Manufacturing Handoff",
    description: "Full technical documentation packages prepared for seamless transition to mass production.",
    icon: Wrench,
    span: "lg:col-span-4",
    featured: false
  }];
  return;
}